import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isArray from 'lodash/isArray';

/**
 * @returns {{
 *  formData: import('zod').z.infer<typeof import("./stubs").FORM_SCHEMA>,
 *  slaOptions: ReturnType<typeof createSlaOptions>,
 * }}
 * */
export const createFormData = (data = {}) => {
  const carriers = _get(data, 'carriers', []);
  const preferredCarrier = _get(data, 'preferredCarrier', {});

  const isEnabled = _get(preferredCarrier, 'is_enabled', false);
  const carrierId = _get(preferredCarrier, 'carrier', null);
  const slaId = _get(preferredCarrier, 'sla', null);

  const formData = {
    is_enabled: isEnabled,
    sla: null
  };

  const slaOptions = createSlaOptions(carriers);

  if (isEnabled) {
    const carrier = slaOptions.find(({ id }) => id === carrierId);
    const slas = _get(carrier, 'options');
    if (slas) {
      formData.sla = slas.find(({ value }) => value === slaId) || null;
    }
  }

  return {
    formData,
    slaOptions
  };
};

/** @param {import('zod').z.infer<typeof import("./stubs").FORM_SCHEMA} data */
export const createPayload = (data = {}) => {
  const isEnabled = _get(data, 'is_enabled', false);
  const carrierId = _get(data, 'sla.carrierId', null);
  const slaId = _get(data, 'sla.value', null);

  return {
    is_enabled: isEnabled,
    carrier: isEnabled ? carrierId : null,
    sla: isEnabled ? slaId : null
  };
};

/**
 * @returns {{
 *  id: string,
 *  label: string,
 *  options: { label: string, value: string, carrierId: string, carrierName: string }[]}[]
 * }}
 */
function createSlaOptions(carriers = []) {
  if (!_isArray(carriers)) return [];

  return carriers.reduce((acc, carrier) => {
    const id = _get(carrier, 'id', '');
    const slas = _get(carrier, 'slas', []);
    const carrierName = _get(carrier, 'name', '');
    const carrierSSId = _get(carrier, 'carrier_id', '');
    const isCarrierEnabled = _get(carrier, 'is_enabled', false);
    const carrierLabel = `${carrierName} ${
      carrierSSId ? `(${carrierSSId})` : ''
    }`;

    if (isCarrierEnabled && _isArray(slas)) {
      const options = slas.reduce((acc, sla) => {
        const slaId = _get(sla, 'id', '');
        const slaName = _get(sla, 'name', '');
        const isSlaActive = _get(sla, 'is_active', '');

        if (isSlaActive) {
          acc.push({
            label: slaName,
            value: slaId,
            carrierId: id,
            carrierName: carrierLabel
          });
        }
        return acc;
      }, []);

      if (!_isEmpty(options)) {
        acc.push({
          id,
          label: carrierLabel,
          options
        });
      }
    }
    return acc;
  }, []);
}
